module.exports = __webpack_public_path__ + "img/obs_sea_warning.383d446b.svg";